<template>
  <div>
    <h3 v-if="titled" class="mb-5">
      {{ $tt('blog.categories') }}
    </h3>

    <div v-if="variant == 'links'" class="flex col gap-2">
      <AppLink
        v-for="category in categories"
        :to="buildCategoryUrl(category.slug)"
        plain
      >
        {{ category.name }} ({{ category.count }})
      </AppLink>
    </div>
    <div v-else-if="variant == 'chips'" class="chips flex wrap">
      <AppChip v-for="category in categories" :to="buildCategoryUrl(category.slug)">
        {{ category.name }}
      </AppChip>
    </div>
    <div v-else-if="variant == 'menu'" class="menu">
      <v-menu full-width>
        <template #activator="{ props }">
          <MenuBtn v-bind="props" :label="$tt('blog.categories')" />
        </template>
        <v-list>
          <AppListItem
            v-for="category in categories"
            :key="category.slug"
            :to="buildCategoryUrl(category.slug)"
          >
            {{ category.name }}
          </AppListItem>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script setup lang="ts">
import { buildCategoryUrl } from '~/helpers/blog';

defineProps<{
  titled?: boolean;
  variant: 'chips' | 'links' | 'menu';
}>();

const { getCategories } = useWordpress();
const { data } = await useAsyncData('categories', () => getCategories());
const categories = data.value?.filter(c => c.count);
</script>

<style scoped>
.chips {
  gap: var(--space-3) var(--space-6);
}
</style>